// @flow
import { Map } from 'immutable';
import loading from './../utilities/loading';
import {
  UPLOAD_SUCCESS,
  UPLOAD_FAIL,
  UPLOAD_PROGRESS,
  UPLOAD_PAUSE,
  UPLOAD_RESUME,
  UPLOAD_CANCEL,
  UPLOAD_CLEAR_STATUS,
} from './../types/upload';
import {
  SIGN_OUT,
} from './../types/auth';

const INITIAL_MAP = Map({
  'uploadMessage': {
    result: null,
    type: 'info',
    filesCount: null,
    text: '',
  },
  'uploadLoading': false,
  'uploadProgress': 0,
  'uploadFileName': ''
});

const UploadReducer = (state = INITIAL_MAP, action) => {
 
  switch (action.type) {    
    case UPLOAD_SUCCESS:
      loading.stop();
      return state
        .set('uploadProgress', 0)
        .set('uploadMessage', { result: 'success', type: 'info', text: 'Upload finished', filesCount: action.filesCount })
        .set('uploadLoading', false);

    case UPLOAD_FAIL:
      loading.stop();
      return state
        .set('uploadMessage', { result: 'fail', type: 'error', text: action.uploadMessage ? action.uploadMessage : 'Upload failed' })
        .set('uploadLoading', false);

    case UPLOAD_PROGRESS:
      loading.start();
      if (action.uploadFileName) {
        return state
          .set('uploadFileName', action.uploadFileName)
          .set('uploadProgress', action.updateUploadProgress)
          .set('uploadMessage', { result: 'progress', type: 'info', text: 'Uploading' })
          .set('uploadLoading', true);
      } else {
        return state
          .set('uploadProgress', action.updateUploadProgress)
          .set('uploadMessage', { result: 'progress', type: 'info', text: 'Uploading' })
          .set('uploadLoading', true);
      }

    case UPLOAD_PAUSE:
      loading.stop();
      return state
        .set('uploadMessage', { result: 'pause', type: 'info', text: 'Upload paused' })
        .set('uploadLoading', false);

    case UPLOAD_RESUME:
      loading.start();
      return state
        .set('uploadMessage', { result: 'resume', type: 'info', text: 'Upload resumed' })
        .set('uploadLoading', true);

    case UPLOAD_CANCEL:
      loading.stop();
      return state
        .set('uploadProgress', 0)
        .set('uploadMessage', { result: 'cancel', type: 'info', text: 'Upload canceled' })
        .set('uploadLoading', false);

    case UPLOAD_CLEAR_STATUS:
    return state
        .set('uploadFileName', '')
        .set('uploadProgress', 0)
        .set('uploadMessage', { result: null, type: 'info', text: '' })
        .set('uploadLoading', false);

    case SIGN_OUT:
      return INITIAL_MAP;

    default:
      return state;
  }
};

export default UploadReducer;


// WEBPACK FOOTER //
// ./src/reducers/upload.jsx